import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan, faPen, faEye } from "@fortawesome/free-solid-svg-icons";
import Pagination_Holder from "../../../../../../../../common/common_components/pagination_holder/Pagination_Holder";
import Image_Show_Modal from "../../../../../../../../common/common_modal/image_show_modal/image_show_modal";
import { formatDate } from "../../../../../../../../utils/common";
import Measurement_Uncertainity_Edit_Offcanvas from "../Measurement_Uncertainity_Edit_Offcanvas/Measurement_Uncertainity_Edit_Offcanvas";
import Delete_offcanvas from "../../../../../../../../common/common_offcanvas/delete_offcanvas/Delete_offcanvas";
import { useDispatch, useSelector } from "react-redux";
import { FixIDS } from "../../../../../../../../utils/fixIDS";
import {
  Delete,
  GetAll,
} from "../../../../../../../../features/admin/quality_management/process_requirement/measurement_uncertainty/Slice";

function Measurement_Uncertainty_table({
  measurementdatadetails,
  currentPage,
  setCurrentPage,
  fetchCustomers,
}) {
  const tableData = measurementdatadetails?.data || [];

  const totalPages = measurementdatadetails?.total_pages || 1;
  const totalEntries = measurementdatadetails?.total || 0;

  const [showEdit, setEdit] = useState(false);
  const [showEditId, setEditId] = useState(null);

  const [showDelete, setDelete] = useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    if (measurementdatadetails?.current_page) {
      setCurrentPage(measurementdatadetails.current_page);
    }
  }, [measurementdatadetails]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Date formatter
  const formatDateTime = (dateStr) => {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    return date.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  /* ================= DELETE ================= */
  const handleDelete = async () => {
    if (!selectedDeleteId) return;

    try {
      await dispatch(Delete(selectedDeleteId)).unwrap(); // call redux thunk
      await fetchCustomers(); // refresh the table
      // setDelete(false); // close offcanvas
      setSelectedDeleteId(null); // reset
    } catch (err) {
      console.error("Delete failed", err);
      alert("Delete failed");
    }
  };

  const permissions = useSelector((state) => state.auth.permissions);

  const haveEditPermission = permissions?.includes(
    FixIDS.measurement_uncertainty.Edit,
  );
  const haveDeletePermission = permissions?.includes(
    FixIDS.measurement_uncertainty.Delete,
  );
  const haveViewPermission = permissions?.includes(
    FixIDS.measurement_uncertainty.View,
  );

  const [show, setShow] = useState(false);
  const [showData, setShowData] = useState("");

  const maxObservations = Math.max(
    ...(tableData || []).map(
      (item) => item.Measurement_Uncertinity_Observations?.length || 0,
    ),
    0,
  );

  return (
    <section className="Imperiality_table">
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped customer_table">
            <thead>
              <tr>
                <th>Sr. No</th>
                <th>Date</th>
                <th>Parameter</th>
                <th>Measurement Period</th>
                <th colSpan={maxObservations}>Observations</th>
                <th>Standard Deviation</th>
                <th>Standard Uncertainity</th>
                <th>Reported Uncertainty </th>
                <th>Combined Uncertainity</th>
                <th>Remark</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {tableData?.length > 0 ? (
                tableData?.map((row, index) => (
                  <tr key={row.id}>
                    <td>{(currentPage - 1) * 10 + index + 1}</td>

                    <td>{formatDate(row.createdAt)}</td>
                    <td>{row.Parameter?.name || "-"}</td>
                    <td>{row.measurement_period || "-"}</td>
                    {Array.from({ length: maxObservations }).map(
                      (_, obsIndex) => (
                        <td key={obsIndex}>
                          {row.Measurement_Uncertinity_Observations?.[obsIndex]
                            ?.observation_value || "-"}
                        </td>
                      ),
                    )}

                    {/* <td>{row.observation_value || "-"}</td> */}

                    <td>{row.standard_deviation || "-"}</td>

                    <td>{row.standard_uncertainity || "-"}</td>

                    <td>{row.type_b_uncertainity || "-"}</td>

                    <td>{row.combined_uncertainity || "-"}</td>

                    <td>{row.remark || "-"}</td>

                    <td>
                      <div className="action_icons">
                        {haveViewPermission && (
                          <FontAwesomeIcon
                            icon={faEye}
                            onClick={() => {
                              setShow(true);
                              setShowData(row);
                            }}
                          />
                        )}

                        {haveEditPermission && (
                          <FontAwesomeIcon
                            icon={faPen}
                            onClick={() => {
                              setEdit(true);
                              setEditId(row.id);
                            }}
                          />
                        )}
                        {haveDeletePermission && (
                          <FontAwesomeIcon
                            icon={faTrashCan}
                            onClick={() => {
                              setSelectedDeleteId(row.id); // store ID
                              setDelete(true); // open offcanvas
                            }}
                          />
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="11" className="text-center">
                    No data found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* FOOTER */}
      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">
            Showing {(currentPage - 1) * 10 + 1} to{" "}
            {Math.min(currentPage * 10, totalEntries)} of {totalEntries} entries
          </p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            currentPage={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>

      <Image_Show_Modal
        onHide={() => setShow(false)}
        show={show}
        showData={showData}
        imgSrc={process.env.REACT_APP_IMG_URL + showData?.attach_file}
      />

      {/* Edit */}
      {haveEditPermission && (
        <Measurement_Uncertainity_Edit_Offcanvas
          fetchCustomers={fetchCustomers}
          show={showEdit}
          handleClose={() => setEdit(false)}
          id={showEditId}
        />
      )}

      {haveDeletePermission && (
        <Delete_offcanvas
          show={showDelete}
          handleClose={() => setDelete(false)}
          handleDelete={handleDelete}
          offcanvasHeading="Delete Measurement Uncertainity"
          massageText={"Measurement Uncertainity"}
        />
      )}
    </section>
  );
}

export default Measurement_Uncertainty_table;
